import React from 'react';

const CampaignZoneFormModal = React.lazy(() => import('../components/FormModal'));
const campaignZoneModalRegistry = {
    crm_campaignZoneId: CampaignZoneFormModal
};
export default campaignZoneModalRegistry;
